import { Redirect, Route, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Customer } from './Customer';
import { CustomerEdit } from './CustomerEdit';
import { Operator } from './Operator';
import { Product } from './Product';
import { ProductEdit } from './ProductEdit';
import { Report } from './Report';
import { SerialCheck } from './SerialCheck';
import { Sku } from './Sku';
import { SkuEdit } from './SkuEdit';
import { SkuProducts } from './SkuProducts';

import { selectUser } from './userSlice';

export function PrivateRoutes() {
  const user = useSelector(selectUser);

  if (!user.isLoggedIn) {
    return <Redirect to="/admin/login" />;
  }

  return (
    <Switch>
      <Route exact path="/admin">
        <Redirect to="/admin/sku" />
      </Route>
      <Route exact path="/admin/customer">
        <Customer />
      </Route>
      <Route exact path="/admin/customer/edit">
        <CustomerEdit />
      </Route>
      <Route exact path="/admin/operator">
        <Operator />
      </Route>
      <Route exact path="/admin/product">
        <Product />
      </Route>
      <Route exact path="/admin/product/edit">
        <ProductEdit />
      </Route>
      <Route exact path="/admin/sku">
        <Sku />
      </Route>
      <Route exact path="/admin/sku/edit">
        <SkuEdit />
      </Route>
      <Route exact path="/admin/sku/:skuId/products">
        <SkuProducts />
      </Route>
      <Route exact path="/admin/product/serial-check">
        <SerialCheck />
      </Route>
      <Route exact path="/admin/report">
        <Report />
      </Route>
    </Switch>
  );
}
